// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalFilter-filterModal-g9ikG {
    background: var(--modal-header-bg);
    border-bottom: unset;
}

.ModalFilter-commonInput-V773K {
    background-color: var(--primary-white-bg);
    border: 1px solid var(--primary-border);
    border-radius: 6px;
    height: 48px;
    padding: 13px 40px 12px 19px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-shadow: unset !important;
            box-shadow: unset !important;
}

.ModalFilter-paddintTop-pOzz3 {
    padding-top: 9px;
}

.ModalFilter-cancelBtn-LO6kE {
    border: 1px solid var(--border-secondary-color);
    border-radius: 6px;
    padding: 8px 20px;
    color: var(--btn-primary-bg);
    text-decoration: unset;
    margin-right: 12px;
    line-height: 24px;
    font-size: 16px;
    font-weight: 500;
}

.ModalFilter-cancelBtn-LO6kE:hover,
.ModalFilter-cancelBtn-LO6kE:focus {
    text-decoration: unset;
    color: var(--btn-primary-bg);
}

.ModalFilter-applyBtn-_pfbS {
    background-color: var(--btn-primary-bg);
    border: 1px solid var(--btn-primary-bg);
    border-radius: 6px;
    color: var(--primary-white-bg);
    padding: 8px 20px;
    font-size: 16px;
    font-weight: 500;
    outline: unset;
    line-height: 24px;
}

.ModalFilter-applyBtn-_pfbS:hover,
.ModalFilter-applyBtn-_pfbS:focus,
.ModalFilter-applyBtn-_pfbS:active,
.ModalFilter-applyBtn-_pfbS:active:hover {
    color: var(--primary-white-bg);
    background-color: var(--btn-primary-bg);
    border-color: var(--btn-primary-bg);
}`, "",{"version":3,"sources":["webpack://./src/components/Transaction/ModalFilter/ModalFilter.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI,yCAAyC;IACzC,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;IAC5B,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,oCAA4B;YAA5B,4BAA4B;AAChC;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,iBAAiB;IACjB,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;IACvC,uCAAuC;IACvC,kBAAkB;IAClB,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;;;;IAII,8BAA8B;IAC9B,uCAAuC;IACvC,mCAAmC;AACvC","sourcesContent":[".filterModal {\n    background: var(--modal-header-bg);\n    border-bottom: unset;\n}\n\n.commonInput {\n    background-color: var(--primary-white-bg);\n    border: 1px solid var(--primary-border);\n    border-radius: 6px;\n    height: 48px;\n    padding: 13px 40px 12px 19px;\n    display: flex;\n    align-items: center;\n    box-shadow: unset !important;\n}\n\n\n.paddintTop {\n    padding-top: 9px;\n}\n\n.cancelBtn {\n    border: 1px solid var(--border-secondary-color);\n    border-radius: 6px;\n    padding: 8px 20px;\n    color: var(--btn-primary-bg);\n    text-decoration: unset;\n    margin-right: 12px;\n    line-height: 24px;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.cancelBtn:hover,\n.cancelBtn:focus {\n    text-decoration: unset;\n    color: var(--btn-primary-bg);\n}\n\n.applyBtn {\n    background-color: var(--btn-primary-bg);\n    border: 1px solid var(--btn-primary-bg);\n    border-radius: 6px;\n    color: var(--primary-white-bg);\n    padding: 8px 20px;\n    font-size: 16px;\n    font-weight: 500;\n    outline: unset;\n    line-height: 24px;\n}\n\n.applyBtn:hover,\n.applyBtn:focus,\n.applyBtn:active,\n.applyBtn:active:hover {\n    color: var(--primary-white-bg);\n    background-color: var(--btn-primary-bg);\n    border-color: var(--btn-primary-bg);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterModal": `ModalFilter-filterModal-g9ikG`,
	"commonInput": `ModalFilter-commonInput-V773K`,
	"paddintTop": `ModalFilter-paddintTop-pOzz3`,
	"cancelBtn": `ModalFilter-cancelBtn-LO6kE`,
	"applyBtn": `ModalFilter-applyBtn-_pfbS`
};
module.exports = ___CSS_LOADER_EXPORT___;
